import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";

// pages / components import
import PriceQuote from "./components.js/priceQuote";
import TransportPage from "./components.js/transportPage";
import Pickup from "./components.js/pickup";
import Delivery from "./components.js/delivery";
import BookShipment from "./components.js/bookShipment";
import ThankYou from "./components.js/Thankyou";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:id" element={<PriceQuote />} />

        <Route path="/transport/:id" element={<TransportPage />} />

        <Route path="/pickup/:id" element={<Pickup />} />

        <Route path="/delivery/:id" element={<Delivery />} />
        <Route path="/bookshipment/:id" element={<BookShipment />} />
        <Route path="/thank-you" element={<ThankYou/>}/>

      </Routes>
    </BrowserRouter>
  );
};

export default App;
